<template>
  <details v-if="entries.length" class="customer-history">
    <summary>
      <v-icon size="19" aria-hidden="true">mdi-history</v-icon>
      <span>{{ title }} <small>{{ entries.length }}</small></span>
      <v-icon size="18" class="customer-history__chevron" aria-hidden="true">mdi-chevron-down</v-icon>
    </summary>
    <div class="customer-history__content">
      <v-select v-if="entries.length > 1"
        :value="selectedEntry.key" :items="entries" item-text="label" item-value="key"
        :label="selectionLabel" outlined dense dark hide-details color="primary"
        class="customer-history__select" @change="selectedKey = $event">
        <template #selection="{ item }"><span class="customer-history__selection">{{ item.label }}</span></template>
        <template #item="{ item }">
          <div class="customer-history__option"><strong>{{ item.range }}</strong><span>{{ item.item.name }}</span></div>
        </template>
      </v-select>
      <div :key="selectedEntry.key" class="customer-history__entry">
        <slot :item="selectedEntry.item" />
      </div>
    </div>
  </details>
</template>

<script>
export default {
  name: "CustomerHubHistory",
  props: {
    items: { type: Array, required: true },
    title: { type: String, required: true },
    selectionLabel: { type: String, default: "Eintrag auswählen" },
  },
  data: () => ({ selectedKey: null }),
  computed: {
    entries() {
      return this.items.map((item, index) => {
        const range = `${this.date(item.start)} – ${this.date(item.end)}`
        return { key: JSON.stringify([item.id, item.start, item.end, index]), label: `${range} · ${item.name}`, range, item }
      })
    },
    selectedEntry() { return this.entries.find(entry => entry.key === this.selectedKey) || this.entries[0] || null },
  },
  watch: { items() { this.selectedKey = null } },
  methods: { date(value) { return value ? this.$moment(value, "YYYY-MM-DD").format("DD.MM.YYYY") : "Ohne Datum" } },
}
</script>

<style scoped>
.customer-history { margin: 16px 0; border-top: 1px solid #ffffff14; color: #e5e5e5; }
.customer-history > summary { display: flex; align-items: center; gap: 10px; min-height: 52px; list-style: none; cursor: pointer; font-size: 13px; }
.customer-history > summary::-webkit-details-marker { display: none; }
.customer-history > summary > span { flex: 1; }
.customer-history > summary small { margin-left: 6px; color: #a6a6a6; font-size: 11px; }
.customer-history > summary .v-icon { color: #a6a6a6; }
.customer-history > summary:focus-visible { outline: 2px solid var(--v-primary-base, #00963f); outline-offset: 3px; border-radius: 4px; }
.customer-history[open] > summary .customer-history__chevron { transform: rotate(180deg); }
.customer-history__content { padding: 4px 0 0; }
.customer-history__select { margin-bottom: 14px; }
.customer-history__selection { min-width: 0; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; }
.customer-history__option { padding: 9px 0; line-height: 1.4; }
.customer-history__option strong { display: block; font-size: 12px; font-weight: 500; }
.customer-history__option span { display: block; font-size: 12px; color: #bdbdbd; white-space: normal; overflow-wrap: anywhere; margin-top: 3px; }
</style>
